export * from './authV1.service';
import { AuthV1Service } from './authV1.service';
export * from './barrelsV1.service';
import { BarrelsV1Service } from './barrelsV1.service';
export * from './employeesV1.service';
import { EmployeesV1Service } from './employeesV1.service';
export * from './fileAttachmentsV1.service';
import { FileAttachmentsV1Service } from './fileAttachmentsV1.service';
export * from './marketingFilesV1.service';
import { MarketingFilesV1Service } from './marketingFilesV1.service';
export * from './messagesV1.service';
import { MessagesV1Service } from './messagesV1.service';
export * from './metadata.service';
import { MetadataService } from './metadata.service';
export * from './productAmountsV1.service';
import { ProductAmountsV1Service } from './productAmountsV1.service';
export * from './productTypesV1.service';
import { ProductTypesV1Service } from './productTypesV1.service';
export * from './tasksV1.service';
import { TasksV1Service } from './tasksV1.service';
export const APIS = [AuthV1Service, BarrelsV1Service, EmployeesV1Service, FileAttachmentsV1Service, MarketingFilesV1Service, MessagesV1Service, MetadataService, ProductAmountsV1Service, ProductTypesV1Service, TasksV1Service];
